export const ROUTES = {
    MAIN: '/main',
    TOOLS_SCORE: '/tools/score',
    TOOLS_SUPPORT: '/tools/support',
    TOOLS_SKILL_ANALYZER: '/tools/skill-analyzer',
    TOOLS_RACE_PLANNER: '/tools/race-planner',
    CHARACTERS_ORIGINAL: '/characters/original',
    CHARACTERS_SUPPORT: '/characters/support',
    SKILLS: '/skills',
    SKILL_DETAIL: '/skill',

    USER: '/user',
    CHARACTER: '/character',
    WEBHOOKS: '/admin/webhooks',
    RACES: '/races',
    RACE: '/race',
    MINIGAMES: '/games',
    ABOUT: '/about',
};
